import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { IFarmStatistics } from 'models/IFarm'
import FarmApiService from 'services/farmApiServices'

/** Общие опции запроса для переиспользования в prefetch и useQuery */
export const statisticsWidgetsQueryOptions = {
	queryKey: ['statistics-for-widgets'] as const,
	queryFn: async (): Promise<IFarmStatistics> => {
		const response = await FarmApiService.getFarmStatistic()
		return response.data
	},
	retry: 2,
	staleTime: 60 * 1000,
	refetchOnMount: false,
}

export interface UseGetStatisticsWidgetsOptions {
	enabled?: boolean
}

export const useGetStatisticsWidgets = (
	options?: UseGetStatisticsWidgetsOptions,
) => {
	const enabled = options?.enabled ?? true

	const { data, refetch, isError, isLoading, error } = useQuery<
		IFarmStatistics,
		AxiosError
	>({
		...statisticsWidgetsQueryOptions,
		enabled,
	})

	return {
		statistics: data,
		loading: isLoading,
		isError,
		error,
		refetch,
	}
}
